'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0%, 50%, 100% {\n    height: 5px;\n    transform: translkateY(0);\n  }\n  25% {\n    height: 30px;\n    background-color: #24a9bd;\n    transform: translateY(-50%)\n  }\n'], ['\n  0%, 50%, 100% {\n    height: 5px;\n    transform: translkateY(0);\n  }\n  25% {\n    height: 30px;\n    background-color: #24a9bd;\n    transform: translateY(-50%)\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #283542;\n  width: 10px;\n  height: 5px;\n  animation-name: ', ';\n  animation-duration: 1.5s;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n'], ['\n  background-color: #283542;\n  width: 10px;\n  height: 5px;\n  animation-name: ', ';\n  animation-duration: 1.5s;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: repeat(6, 10px);\n  grid-gap: 1px;\n  justify-content: center;\n  height: 2em;\n  padding: 2em 0;\n  & ', ' {\n    &:nth-of-type(2) {\n      animation-delay: 0.2s;\n    }\n    &:nth-of-type(3) {\n      animation-delay: 0.4s;\n    }\n    &:nth-of-type(4) {\n      animation-delay: 0.6s;\n    }\n    &:nth-of-type(5) {\n      animation-delay: 0.8s;\n    }\n    &:nth-of-type(6) {\n      animation-delay: 1s;\n    }\n  }\n'], ['\n  display: grid;\n  grid-template-columns: repeat(6, 10px);\n  grid-gap: 1px;\n  justify-content: center;\n  height: 2em;\n  padding: 2em 0;\n  & ', ' {\n    &:nth-of-type(2) {\n      animation-delay: 0.2s;\n    }\n    &:nth-of-type(3) {\n      animation-delay: 0.4s;\n    }\n    &:nth-of-type(4) {\n      animation-delay: 0.6s;\n    }\n    &:nth-of-type(5) {\n      animation-delay: 0.8s;\n    }\n    &:nth-of-type(6) {\n      animation-delay: 1s;\n    }\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var moving = (0, _styledComponents.keyframes)(_templateObject);

var Step = _styledComponents2.default.span(_templateObject2, moving);
var LoadingIndicator = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className;
  return React.createElement(
    'div',
    { className: className },
    React.createElement(Step, null),
    React.createElement(Step, null),
    React.createElement(Step, null),
    React.createElement(Step, null),
    React.createElement(Step, null),
    React.createElement(Step, null)
  );
})(_templateObject3, Step);
var Loading = exports.Loading = function Loading(props /*: {while: bool, children?: React.Node} */) {
  return props.while ? React.createElement(LoadingIndicator, null) : props.children;
};
Loading.propTypes = {
  while: _propTypes2.default.bool
};
Loading.defaultProps = {
  while: true
};
Loading.displayName = 'Loading';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Loading.js
// module id = 640
// module chunks = 0